import * as React from 'react';
import {createBrowserRouter} from 'react-router-dom';
import AuthenticationGatedRoute from '../components/util/AuthenticationGatedRoute/AuthenticationGatedRoute';
import Login from '../pages/auth/Login/Login';
import {RoutePaths} from './RoutePaths';
import LogOut from '../pages/auth/Logout/Logout';
import Home from '../pages/private/Home/Home';
import ForgotPassword from '../pages/auth/ForgotPassword/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword/ResetPassword';
import NotFound from '../pages/NotFound/NotFound';
import Landing from '../pages/public/Landing/Landing';
import OrderSubmitted from '../pages/public/OrderSubmitted/OrderSubmitted';
import {PublicBody} from '../components/layout/PublicBody/PublicBody';
import {AuthBody} from '../components/layout/AuthBody/AuthBody';
import UserManagement from '../pages/private/Configuration/UserManagement/UserManagement';
import Profile from '../pages/private/Profile/Profile';
import OrderManagement from '../pages/private/Configuration/OrderManagement/OrderManagement';
import InventoryManagement from '../pages/private/Configuration/InventoryManagement/InventoryManagement';
import PrivateBody from '../components/layout/PrivateBody/PrivateBody';
import {AdministratorRoute} from '../components/util/AdministratorRoute/AdministratorRoute';
import Export from "../pages/private/Export/Export";
import DepositManagement from "../pages/private/Configuration/DepositManagement/DepositManagement";
import {RoleProtectedRoute} from "../components/util/RoleProtectedRoute/RoleProtectedRoute";


const AppRoutes = createBrowserRouter([
  // private / staff
  {
    path: RoutePaths.privateRoot,
    element:
      <AuthenticationGatedRoute authStateToRedirect={false} redirectRoute={RoutePaths.authPaths.login}>
        <PrivateBody/>
      </AuthenticationGatedRoute>,
    children: [
      {
        path: RoutePaths.privatePaths.configurationPaths.userManagement,
        element: <AdministratorRoute><UserManagement/></AdministratorRoute>
      },
      {
        path: RoutePaths.privatePaths.configurationPaths.inventoryManagement,
        element: <RoleProtectedRoute
          allowedRoles={['Administrator', 'Volunteer', 'Team Member']}><InventoryManagement/></RoleProtectedRoute>
      },
      {
        path: RoutePaths.privatePaths.configurationPaths.withdrawalManagement,
        element: <RoleProtectedRoute
          allowedRoles={['Administrator', 'Volunteer', 'Team Member', 'Warehouse']}><OrderManagement/></RoleProtectedRoute>
      },
      {
        path: RoutePaths.privatePaths.configurationPaths.withdrawalManagementQuery,
        element: <RoleProtectedRoute
          allowedRoles={['Administrator', 'Volunteer', 'Team Member', 'Warehouse']}><OrderManagement/></RoleProtectedRoute>
      },
      {
        path: RoutePaths.privatePaths.configurationPaths.depositManagement,
        element: <RoleProtectedRoute
          allowedRoles={['Administrator', 'Volunteer', 'Warehouse']}><DepositManagement/></RoleProtectedRoute>
      },
      {
        path: RoutePaths.privatePaths.configurationPaths.depositManagementQuery,
        element: <RoleProtectedRoute
          allowedRoles={['Administrator', 'Volunteer', 'Warehouse']}><DepositManagement/></RoleProtectedRoute>
      },
      {path: RoutePaths.privatePaths.export, element: <AdministratorRoute><Export/></AdministratorRoute>},
      {path: RoutePaths.privatePaths.profilePaths.EditPassword, Component: Profile},
      {path: RoutePaths.privatePaths.profilePaths.View, Component: Profile},
      {path: RoutePaths.privatePaths.profilePaths.Edit, Component: Profile}

    ]
  },
  // public
  {
    path: RoutePaths.publicRoot,
    element:
      <AuthenticationGatedRoute authStateToRedirect={true} redirectRoute={RoutePaths.privatePaths.configurationPaths.withdrawalManagement}>
        <PublicBody/>
      </AuthenticationGatedRoute>,
    children: [
      {path: RoutePaths.publicRoot, Component: Landing},
      {path: RoutePaths.publicPaths.orderSubmitted, Component: OrderSubmitted}
    ]
  },
  // logout - could be under private, but here for clarity
  {path: RoutePaths.authPaths.logout, Component: LogOut},
  // public auth
  {
    path: RoutePaths.authRoot,
    element:
      <AuthenticationGatedRoute authStateToRedirect={true} redirectRoute={RoutePaths.privatePaths.configurationPaths.withdrawalManagement}>
        <AuthBody/>
      </AuthenticationGatedRoute>,
    children: [
      {path: RoutePaths.authPaths.login, Component: Login},
      {path: RoutePaths.authPaths.forgotPassword, Component: ForgotPassword},
      {path: RoutePaths.authPaths.resetPassword, Component: ResetPassword}
    ]
  },
  // any other route - not found
  {path: RoutePaths.all, Component: NotFound}
]);

export default AppRoutes;
